import React, { FunctionComponent } from 'react';
import ReactDOMServer from 'react-dom/server';
import HtmlToReact, { Parser } from 'html-to-react';

import { IndexStructure, Props } from './index';
import StyledComponent from './styles';

const SectionArticlesArticleWrapper: FunctionComponent<Props> = ({ article, children }) => {
    const htmlToReactParser = new Parser();

    const indexStructure: IndexStructure = {};
    let lastLevel1Id = 0;
    let lastLevel2Id = 0;
    let lastLevel3Id = 0;

    const shouldPreprocessNode = (node, tag: string): boolean => {
        const hasNodeData = node.parent && node.parent.name && node.parent.name === tag && (node.children && node.children[0] || node.data);
        if (!hasNodeData) return false;

        const nodeData = node?.children && node?.children[0]
            ? node?.children[0]
            : node;
        return Boolean(nodeData?.data?.trim());
    };

    const preprocessingInstructions = [{
        replaceChildren: false,
        shouldPreprocessNode(node) {
            return shouldPreprocessNode(node, 'h2');
        },
        preprocessNode(node) {
            const nodeParent = node.children && node.children[0]
                ? node
                : node.parent;

            const nodeData = node.children && node.children[0]
                ? node.children[0]
                : node;

            lastLevel1Id = lastLevel1Id + 1;
            lastLevel2Id = 0;
            lastLevel3Id = 0;
            indexStructure[lastLevel1Id] = {
                key: `1-${lastLevel1Id}`,
                level: 1,
                order: lastLevel1Id,
                text: nodeData?.data,
                elements: {},
            };

            nodeParent.attribs = {
                ...nodeParent.attribs,
                id: `indexl1-${lastLevel1Id}`,
            };
        },
    }, {
        replaceChildren: false,
        shouldPreprocessNode(node) {
            return shouldPreprocessNode(node, 'h3');
        },
        preprocessNode(node) {
            const nodeParent = node.children && node.children[0]
                ? node
                : node.parent;
            const nodeData = node.children && node.children[0]
                ? node.children[0]
                : node;

            if (indexStructure[lastLevel1Id]) {
                lastLevel2Id = lastLevel2Id + 1;
                lastLevel3Id = 0;
                indexStructure[lastLevel1Id].elements[lastLevel2Id] = {
                    key: `2-${lastLevel2Id}`,
                    level: 2,
                    order: lastLevel2Id,
                    text: nodeData?.data,
                    elements: {},
                };
            } else {
                lastLevel1Id = lastLevel1Id + 1;
                lastLevel2Id = 0;
                lastLevel3Id = 0;
                indexStructure[lastLevel1Id] = {
                    key: `1-${lastLevel1Id}`,
                    level: 1,
                    order: lastLevel1Id,
                    text: nodeData?.data,
                    elements: {},
                };
            }

            nodeParent.attribs = {
                ...nodeParent.attribs,
                id: `indexl2-${lastLevel2Id}`,
            };
        },
    }, {
        replaceChildren: false,
        shouldPreprocessNode(node) {
            return shouldPreprocessNode(node, 'h4');
        },
        preprocessNode(node) {
            const nodeParent = node.children && node.children[0]
                ? node
                : node.parent;

            const nodeData = node.children && node.children[0]
                ? node.children[0]
                : node;

            if (indexStructure[lastLevel1Id]) {
                if (indexStructure[lastLevel1Id].elements[lastLevel2Id]) {
                    lastLevel3Id = lastLevel3Id + 1;
                    indexStructure[lastLevel1Id].elements[lastLevel2Id].elements[lastLevel3Id] = {
                        key: `3-${lastLevel3Id}`,
                        level: 3,
                        order: lastLevel3Id,
                        text: nodeData?.data,
                        elements: {},
                    };
                } else {
                    lastLevel2Id = lastLevel2Id + 1;
                    lastLevel3Id = 0;
                    indexStructure[lastLevel1Id].elements[lastLevel2Id] = {
                        key: `2-${lastLevel2Id}`,
                        level: 2,
                        order: lastLevel2Id,
                        text: nodeData?.data,
                        elements: {},
                    };
                }
            } else {
                lastLevel1Id = lastLevel1Id + 1;
                lastLevel2Id = 0;
                lastLevel3Id = 0;
                indexStructure[lastLevel1Id] = {
                    key: `1-${lastLevel1Id}`,
                    level: 1,
                    order: lastLevel1Id,
                    text: nodeData?.data,
                    elements: {},
                };
            }

            nodeParent.attribs = {
                ...nodeParent.attribs,
                id: `indexl3-${lastLevel3Id}`,
            };
        },
    }];


    const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
    const processingInstructions = [{
        shouldProcessNode: () => true,
        processNode: processNodeDefinitions.processDefaultNode,
    }];

    const content = ReactDOMServer.renderToStaticMarkup(
        htmlToReactParser.parseWithInstructions(
            article?.content,
            () => true,
            processingInstructions,
            preprocessingInstructions
        )
    );

    return (
        <StyledComponent className="section-articles-article-wrapper">
            {children(content, indexStructure)}
        </StyledComponent>
    );
};

export default SectionArticlesArticleWrapper;
